import type { AgencyVisibility } from '../interfaces/agency.interface'

/**
 * Defines which visibility transitions are allowed for an agency owner.
 * Admin transitions (pending_review → public/rejected) are handled server-side only.
 */
const PENDING_REVIEW: AgencyVisibility = 'pending_review'

const ownerTransitionMap: Record<AgencyVisibility, AgencyVisibility[]> = {
  draft: ['private'],
  private: [PENDING_REVIEW],
  [PENDING_REVIEW]: ['private'],
  rejected: [],
  public: [],
}

const editableVisibilitySet = new Set<AgencyVisibility>(['draft', 'private', 'rejected', 'public'])

export const canOwnerTransitionTo = (from: AgencyVisibility, to: AgencyVisibility): boolean =>
  ownerTransitionMap[from].includes(to)

export const getOwnerTransitionList = (from: AgencyVisibility): AgencyVisibility[] =>
  ownerTransitionMap[from]

export const isAgencyEditable = (visibility: AgencyVisibility): boolean =>
  editableVisibilitySet.has(visibility)

export const isAgencyChattable = (_visibility: AgencyVisibility): boolean => true
